module.exports = __webpack_public_path__ + "img/yuleyongpin_shrz.382b39c2.png";